import styles from './styles.module.css'

export function Header({ text }: { text: string }) {
  return (
    <div className={styles.container}>
      <wui-text variant="lg-medium" color="primary" align="center">
        {text}
      </wui-text>
      <wui-tag size="sm" variant="accent">
        BETA
      </wui-tag>
    </div>
  )
}
